export default {
  setSpecs: (state, payload) => {
    if (payload) state.specs = payload
  }
}
